<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid
      ref="grid"
      metaKey="JyReserveWork"
      rightWidth="20%"
      :metaInited="metaInited"
      :handleQuery="handleQuery"
      :handleData="handleData"
      :searchPosition="patientId ? 'top' : 'left'"
      @row-click="rowClick"
    >
      <template #billTimeSearch>
        <el-date-picker
          style="width: 100%"
          size="mini"
          v-model="filterDate"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
          valueFormat="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template #rightAside>
        <ReserveRecommend
          ref="recommend"
          :key="editRow.id"
          :isRecommend="editRow.status == 'wait' || editRow.status == 'cancel'"
          :resId="editRow.resourceId || ''"
          :resDate="editRow.reserveDate"
          :resScheduleId="editRow.scheduleId || ''"
          :billId="editRow.id"
          :rows="rows"
          @reserved="reserved"
        ></ReserveRecommend>
      </template>
      <template #pageRight> </template>
      <template #bottom>
        <div style="height: 300px; position: relative">
          <div
            v-if="editRow.id"
            style="position: absolute; top: 0; right: 10px; z-index: 1000"
          >
            <el-button
              v-if="editRow.status == 'ok'"
              type="success"
              icon="el-icon-success"
              :disabled="signable"
              size="mini"
              @click="signBill"
            >
              签到
            </el-button>
            <el-button
              v-if="editRow.status == 'sign'"
              type="success"
              icon="el-icon-printer"
              size="mini"
              @click="print(editRow)"
            >
              打印凭条
            </el-button>
            <el-button
              v-if="editRow.status == 'ok' || editRow.status == 'sign'"
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="cancelApply"
            >
              取消
            </el-button>
          </div>
          <RecordDetail
            style="flex: 1"
            ref="detail"
            :billId="editRow.id"
          ></RecordDetail>
        </div>
      </template>
      <template #gridBtnAfter>
        <el-row type="flex" justify="space-between" align="middle">
          <el-row>
            <el-button
              icon="el-icon-thumb"
              size="mini"
              type="success"
              @click="oneKeyReserve"
            >
              一键预约
            </el-button>
            <el-button
              icon="el-icon-success"
              size="mini"
              type="success"
              @click="batchSign"
            >
              批量签到
            </el-button>
          </el-row>

          <el-button
            icon="el-icon-refresh"
            size="mini"
            type="danger"
            @click="manualSyncBills"
          >
            手动同步
          </el-button>
        </el-row>
      </template>
      <template #status="{ row }">
        <el-tag :type="statusMap[row.status].type" size="small">
          <span :class="payStatusMap[row.payStatus].type">
            {{ payStatusMap[row.payStatus].label }}
          </span>
          |
          <span>{{ statusMap[row.status].label }}</span>
        </el-tag>
      </template>
      <template #reserveDate="{ row }">
        <div v-if="row.scheduleId">
          {{ row.reserveDate }} {{ row.startPoint }}-{{ row.endPoint }}
        </div>
        <span v-else>-</span>
      </template>
      <template #patientGender="{ row }">
        {{ getGenderLabel(row.patientGender) }}
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
import { hiprint } from "../print/index";
import moment from "moment";
import { sign, cancel, oneReserve, syncBills, getNote } from "@/api/jy/reserve";
import ReserveRecommend from "./assist/ReserveRecommend.vue";
import RecordDetail from "./RecordDetail.vue";
import { getClinicTypeLabel, getGenderLabel } from "@/util/util";
import { getSignPrintTemp } from "@/api/jy/resource-config";
let hiprintTemplate;
export default {
  components: {
    ReserveRecommend,
    RecordDetail,
  },
  data() {
    const start = moment().subtract(7, "d").toDate();
    return {
      hiprintTemplate: {},
      patientId: "",
      statusMap: {
        wait: {
          label: "待预约",
          type: "info",
        },
        ok: {
          label: "已预约",
          type: "parimry",
        },
        cancel: {
          label: "已取消",
          type: "warning",
        },
        sign: {
          label: "已签到",
          type: "success",
        },
        check: {
          label: "已检查",
          type: "success",
        },
        report: {
          label: "已出报告",
          type: "success",
        },
        stop: {
          label: "已停诊",
          type: "danger",
        },
        scrap: {
          label: "已作废",
          type: "danger",
        },
        undo: {
          label: "已爽约",
          type: "danger",
        },
      },
      payStatusMap: {
        paid: {
          label: "已支付",
          type: "color-success",
        },
        unpaid: {
          label: "未支付",
          type: "color-info",
        },
        refund: {
          label: "已退费",
          type: "color-danger",
        },
      },
      loading: false,
      showDialog: false,
      dialogLoading: false,
      editRow: {},
      hosId: "first",
      filterDate: [start, new Date()],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.patientId) {
      this.patientId = this.$route.query.patientId;
    }
  },
  computed: {
    signable() {
      if (this.editRow.id) {
        return this.editRow.reserveDate != moment().format("YYYY-MM-DD");
      }
      return true;
    },
    rows() {
      let rows = this.$refs.grid.tableSelectRows;
      return rows;
    },
  },
  methods: {
    getClinicTypeLabel,
    getGenderLabel,
    metaInited(option) {
      if (this.patientId) {
        option.columns.forEach((c) => {
          c.isSearch = c.code == "billTime";
        });
        option.columns.find((c) => c.code == "billTime").searchSlot = true;
      } else {
        option.columns.find((c) => c.code == "billTime").searchSlot = true;
      }
    },
    handleQuery(param) {
      if (this.filterDate.length) {
        let start = moment(this.filterDate[0]).format("YYYY-MM-DD");
        let end = moment(this.filterDate[1]).format("YYYY-MM-DD");
        param.billTime = start + " 00:00:00," + end + " 23:59:59";
      }
      if (this.patientId) {
        param.patientId = this.patientId;
      }
      return param;
    },
    handleData(data) {
      if (data.length) {
        this.editRow = data[0];
      }
    },
    reloadGrid() {
      this.$refs.grid.reload();
    },
    rowClick(row) {
      this.editRow = row;
    },
    oneKeyReserve() {
      let billIds = this.$refs.grid.tableSelectRows.map((c) => c.id);
      if (billIds.length) {
        this.$refs.container.confirm({ msg: "确认一键预约？" }).then(() => {
          this.loading = true;
          oneReserve(billIds.join(","))
            .then((res) => {
              this.loading = false;
              this.$refs.grid.reload();
            })
            .catch(() => {
              this.loading = false;
            });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择要一键预约的申请单!",
        });
      }
    },
    reserved(res, schedule, billIds) {
      schedule.resCount += this.editRow.numCount;
      this.editRow.status = "ok";
      this.editRow.resourceId = res.id;
      this.editRow.resourceName = res.name;
      this.editRow.scheduleId = schedule.id;
      this.editRow.reserveDate = schedule.scheduleDate;
      this.editRow.startPoint = schedule.startPoint;
      this.editRow.endPoint = schedule.endPoint;

      if (billIds) {
        let rows = this.$refs.grid.tableData;
        let mergeBills = billIds.split(",");
        rows.forEach((row) => {
          mergeBills.forEach((m) => {
            if (row.id == m) {
              row.status = "ok";
              row.resourceId = res.id;
              row.resourceName = res.name;
              row.scheduleId = schedule.id;
              row.reserveDate = schedule.scheduleDate;
              row.startPoint = schedule.startPoint;
              row.endPoint = schedule.endPoint;
            }
          });
        });
      }
      this.showDialog = false;
      this.$refs.detail.loadData();
    },
    batchSign() {
      let rows = this.$refs.grid.tableSelectRows;
      if (rows.length) {
        this.$refs.container.confirm({ msg: "确认批量签到？" }).then(() => {
          this.loading = true;
          rows.forEach((row) => {
            sign({
              billId: row.id,
              isCheck: false,
              isEmergency: this.isEmergency,
            })
              .then((res) => {
                this.$message({
                  type: "success",
                  message: "签到成功！",
                });
                this.loading = false;
                row.status = "sign";
                this.$refs.detail.loadData();
                //this.print(row); //打印凭条
              })
              .catch(() => {
                this.loading = false;
              });
          });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择要批量签到的申请单!",
        });
      }
    },
    signBill() {
      this.$refs.container.confirm({ msg: "确认预约签到？" }).then(() => {
        this.loading = true;
        sign({ billId: this.editRow.id })
          .then(() => {
            this.$message({
              type: "success",
              message: "签到成功！",
            });
            this.loading = false;
            this.editRow.status = "sign";
            this.$refs.detail.loadData();
            //this.print(this.editRow) //打印凭条
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    cancelApply() {
      this.$refs.container.confirm({ msg: "确认取消预约？" }).then(() => {
        this.loading = true;
        cancel({ billId: this.editRow.id })
          .then(() => {
            this.$message({
              type: "success",
              message: "取消成功！",
            });
            this.loading = false;
            this.editRow.status = "cancel";
            this.$refs.detail.loadData();
            this.$refs.recommend.loadData();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    manualSyncBills() {
      this.$refs.container
        .confirm({ msg: "确认手动同步检查申请单？" })
        .then(() => {
          this.loading = true;
          syncBills()
            .then(() => {
              this.$message({
                type: "success",
                message: "同步申请单成功！",
              });
              this.loading = false;
              this.$refs.grid.reload();
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    print(row) {
      getSignPrintTemp(row.resourceId).then((res) => {
        let template = res.data.data;
        let printData = Object.assign({}, row);
        if ("note" in template.printData) {
          getNote(row.projectId, row.partNames).then((r) => {
            printData.note = r.data.data;
            this.openHiprint(row, template, printData);
          });
        } else {
          this.openHiprint(row, template, printData);
        }
      });
    },
    openHiprint(row, template, printData) {
      let age = this.getAge(row.patientBirthday);
      printData.billNo = row.id;
      printData.age = age + "岁";
      printData.barcode = row.patientId; //打印条码
      printData.sex = row.patientGender == "W" ? "女" : "男";
      printData.checkTime =
        row.reserveDate + " " + row.startPoint + "-" + row.endPoint;
      printData.place = template.place;
      this.hiprintTemplate = hiprintTemplate = new hiprint.PrintTemplate({
        template: template.json,
        settingContainer: "#template-preview-setting",
        paginationContainer: "#template-preview-printPagination",
      });
      //this.hiprintTemplate.print(printData, {})
      hiprintTemplate.print2(printData, {});
    },
    getAge(birthday) {
      if (birthday) {
        birthday = birthday.split("-");
        let date = new Date();
        let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        let age = today.map((val, index) => {
          return val - birthday[index];
        });
        if (age[2] < 0) {
          let lastMonth = new Date(today[0], today[1], 0);
          age[1]--;
          age[2] += lastMonth.getDate();
        }
        if (age[1] < 0) {
          age[0]--;
          age[1] += 12;
        }
        return age[0];
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.el-calendar-table {
  .el-calendar-day {
    height: 40px !important;
  }
}
</style>
